import React, {memo} from 'react';
import {Grid, useMediaQuery} from "@mui/material";
import DownloadCSVButton from "../report/export/DownloadCSVButton";
import DownloadGroupSummaryCSVButton from '../report/export/DownloadGroupSummaryCSVButton';
import { getPayoutsReportUrl, getPayoutsGroupSummaryUrl } from "./request/payouts-requests";
import { verbiage } from "./payouts-report-verbiage.js";

const groupSummaryOptions = [
  {value: 'location', label: verbiage.groupByLocation},
];

const PayoutsExportCSVs = (props) => {
  const { item, query, disabled = false } = props;
  const isMd = useMediaQuery(theme => theme.breakpoints.up('md'));
  const payoutsReportUrl = getPayoutsReportUrl(query);

  return (
    <Grid item={item} container gap={4} justifyContent={isMd ? 'flex-end' : 'space-between'} xs={12} md>
      <Grid item>
        <DownloadCSVButton reportUrl={payoutsReportUrl} title={verbiage.downloadReport} disabled={disabled} />
      </Grid>
      <DownloadGroupSummaryCSVButton
        queryParams={query}
        groupByOptions={groupSummaryOptions}
        getUrl={getPayoutsGroupSummaryUrl}
        disabled={disabled}
      />
    </Grid>
  )
}
export default memo(PayoutsExportCSVs);